import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { UncontrolledTooltip, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployeeFace as onGetEmployeeFaces, addNewEmployeeFace as onAddNewEmployeeFace, updateEmployeeFace as onUpdateEmployeeFace, deleteEmployeeFace as onDeleteEmployeeFace, getEmployeeFaceLoading, resetEmployeeFaceState } from "../../../store/employeeFace/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { api } from "../../../config";

const EmployeeFace = () => {
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, employeeFaces, isEmployeeFaceCreated, isEmployeeFaceSuccess, loading, error } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    employeeFaces: state.EmployeeFace.employeeFaces,
    isEmployeeFaceCreated: state.EmployeeFace.isEmployeeFaceCreated,
    isEmployeeFaceSuccess: state.EmployeeFace.isEmployeeFaceSuccess,
    loading: state.EmployeeFace.loading,
    error: state.EmployeeFace.error,
  }));

  const [employeeFaceList, setEmployeeFaceList] = useState([]);
  const [employeeFace, setEmployeeFace] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModalMulti, setApproveModalMulti] = useState(false);

  const defaultdate = () => {
    return moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const onClickApprove = (employeeFace) => {
    setEmployeeFace(employeeFace);
    setApproveModal(true);
  };

  const onClickDisapprove = (employeeFace) => {
    setEmployeeFace(employeeFace);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);
  useEffect(() => {
    if (companySelected) {
      dispatch(resetEmployeeFaceState());
      dispatch(onGetEmployeeFaces({ companyId: companySelected?.value ?? "", status: 2, type: "face" }));
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(employeeFaces)) {
      setEmployeeFaceList(employeeFaces);
      setInfo(employeeFaces[employeeFaces.length - 1]);
    }
    else {
      setEmployeeFaceList([]);
    }
  }, [employeeFaces]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  const columns = useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          return <input type="checkbox" className="dataCheckbox form-check-input" value={cellProps.row.original.id} />;
        },
        id: "#",
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-light"
                onClick={() => {
                  let data = cellProps.row.original;
                  setInfo(data);
                }}>
                <i className="ri-eye-line fs-15"></i>
              </Link>
              {cellProps.row.original.isFaceApproved && cellProps.row.original.face_value && (
                <button
                  className="btn-label btn btn-sm btn-soft-warning fs-12 me-0"
                  onClick={() => {
                    let data = cellProps.row.original;
                    data.setApprovedType = "Not";
                    onClickApprove(data);
                  }}
                >
                  {" "}
                  <i className="ri-close-circle-line label-icon align-middle fs-16 me-1"></i> Disapprove
                </button>
              )}
              {!cellProps.row.original.isFaceApproved && cellProps.row.original.face_value && (
                <button
                  className={userType === "admin" ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("approveEmployeeFace") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"}
                  onClick={() => {
                    let data = cellProps.row.original;
                    data.setApprovedType = "Yes";
                    onClickApprove(data);
                  }}
                >
                  {" "}
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Karyawan",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "NIK",
        accessor: "code",
        filterable: true,
      },
      {
        Header: "Posisi",
        accessor: "employee_user.user_position.name",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div>
              <p className="mb-0 text-muted">{data.employee_user && data.employee_user.user_position ? data.employee_user.user_position.name : "-"}</p>
              <p className="mb-0">{data.employee_user && data.employee_user?.user_department ? data.employee_user?.user_department?.name : "-"}</p>
            </div>
          );
        },
      },
      {
        id: "Departemen",
        Header: "Departemen",
        accessor: "employee_user?.user_department?.name",
        filterable: true,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return data.employee_user && data.employee_user?.user_department ? data.employee_user?.user_department?.name : "-";
        },
      },
      {
        Header: "Status",
        accessor: (a) => (a.isFaceApproved ? "Approved" : a.face_value ? "Waiting Approval" : a.isC ? "Not Registered" : ""),
        filterable: true,
        Cell: (cellProps) => {
          switch (cellProps.row.original.isFaceApproved) {
            case false:
              if (cellProps.row.original.face_value) return <span className="badge text-uppercase badge-soft-warning">Waiting Approval</span>;
              else return <span className="badge text-uppercase badge-soft-danger">Not Registered</span>;
            default:
              return <span className="badge text-uppercase badge-soft-success">Approved</span>;
          }
        },
      },
      {
        id: "Approval",
        Header: "Disetujui Oleh",
        accessor: "face_approvedby.name",
        filterable: true,
      },
      {
        id: "Tanggal",
        Header: "Tanggal",
        accessor: "approvedat",
        filterable: true,
        Cell: (cl) => handleValidDate(cl.row.original.approvedat),
      },
    ],
    [userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: employeeFaceList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Departemen", "Approval", "Tanggal"],
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveEmployeeFace = () => {
    if (employeeFace) {
      employeeFace.setApprove = true;
      employeeFace.approveFace = true;
      dispatch(onUpdateEmployeeFace(employeeFace));
      setApproveModal(false);
    }
  };

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  function handleEmployeeFaceStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: 2,
      type: "face",
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetEmployeeFaces(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setEmployeeFaceList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetEmployeeFaceState());
    dispatch(onGetEmployeeFaces({ companyId: companySelected?.value ?? "", status: 2, type: "face" }));
  };

  document.title = "Registrasi Wajah | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={employeeFaceList} />
      <ApproveModal data={employeeFace ? employeeFace.name : ""} show={approveModal} onApproveClick={handleApproveEmployeeFace} onCloseClick={() => setApproveModal(false)} />
      <Container fluid>
        <BreadCrumb title="Penggajian" pageTitle="Registrasi Wajah" loading={loading} />
        <Row>
          <Col xxl={8}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      {" "}
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <CardBody className="text-left">
                <div className="row">
                  <div className=" col-lg-12">
                    <h5 className="mt-3 mb-3">{info && info ? info.name : ""}</h5>
                  </div>
                  <div className="col-lg-12">
                    <table className="table table-responsive table-striped fs-12">
                      <tbody>
                        <tr>
                          <td className="p2 w-50"> Perusahaan</td>
                          <td className="p2 w-50">{info.employee_company && info.employee_company.name ? info.employee_company.name : "-"} </td>
                        </tr>
                        <tr>
                          <td className="p2 w-50">Tanggal Bergabung</td>
                          <td className="p2 w-50">{info.joinat ? handleValidDate(info.joinat) : "-"}</td>
                        </tr>
                        <tr>
                          <td className="p2 w-50">Departemen </td>
                          <td className="p2 w-50">{info.employee_user && info.employee_user?.user_department ? info.employee_user?.user_department?.name : "-"}</td>
                        </tr>
                        <tr>
                          <td className="p2 w-50"> Jabatan</td>
                          <td className="p2 w-50">{info.employee_user && info.employee_user.user_position ? info.employee_user.user_position.name : "-"} </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </CardBody>
              <CardBody className="text-center">
                {info.imageFace && info.imageFace ? (
                  <img src={`${api.MEDIA_URL}/media/${info.imageFace}`} alt="" className="img-fluid" />
                ) : (
                  <div>
                    <div className="position-relative d-inline-block">
                      <div className="avatar-xl mb-3">
                        <div className="avatar-title bg-light rounded-circle">
                          <img src={defaultImg} alt="" className="avatar-lg rounded-circle object-cover" />
                        </div>
                      </div>
                    </div>
                    <p>{info.name} belum melakukan registrasi wajah</p>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EmployeeFace;
